module.exports = __webpack_public_path__ + "img/franchising_help_support.c95bed13.png";